export const PORTAL_CONTAINERS = {
	SHOP_EXPANDED: "portal-root-shop-expanded",
	OFFICE_BAR: "portal-root-office-bar",
	DEMO_TUTORIAL_MODAL: "portal-root-demo-tutorial-modal",
	DEMO_TUTORIAL_HIGHLIGHT: "portal-root-demo-tutorial-highlight",
	MENU: "portal-root-menu",
	EDITABLE_MODAL: "portal-root-editable-modal",
	EDITABLE_MODAL_CONFIRM: "portal-root-editable-modal-confirm",
	HOVER_TEXT: "portal-root-hover-text",
	BUTTON_WITH_CONFIRM: "portal-root-button-with-confirm",
	INFO_MODAL: "portal-root-info-modal",
	ASSIGNED_BLOCKS_MODAL: "portal-root-assigned-blocks-modal",
	SCHEDULE_PUZZLE_LAB_MODAL: "portal-root-schedule-puzzle-lab-modal",
	CHECKOUT: "portal-root-checkout",
	TRAINER_SLIDER: "portal-root-trainer-slider",
	TRAINER_LEADERBOARD: "portal-root-trainer-leaderboard",
	TRAINER_MESSAGE: "portal-root-trainer-message",
	TOOL: "portal-root-tool",
	INSTRUCTIONS_TOOL: "portal-root-instructions-tool",
	GRADE_MODAL: "portal-root-grade-modal",
	BOOK_MODAL: "portal-root-book-modal",
	VIDEO_MODAL: "portal-root-video-modal",
	HELP_MODAL: "portal-root-help-modal",
	LEFT_NAV_MORE_MODAL: "portal-root-left-nav-more-modal",
	TERMS_MODAL: "portal-root-terms-modal",
	SPINNER: "portal-root-spinner",
	TOOLTIP: "portal-root-tooltip",
	BUG_MODAL: "portal-root-bug-modal",
	BUG_REPORT_STATUS_INDICATOR: "portal-root-bug-report-status-indicator",
	DEMO_SIGNUP_MODAL: "portal-root-demo-signup-modal",
	USER_PULLOUT_MENU: "portal-root-user-pullout-menu",
	INSTRUCTIONS_BUBBLE: "portal-root-instructions-bubble",
	INSTRUCTIONS_MODAL: "portal-root-instructions-modal",
	SOLUTION_KEYBOARD: "portal-root-solution-keyboard",
	TOOLTRAYS_LEFT: "portal-root-tooltrays-left",
	TOOLTRAYS_RIGHT: "portal-root-tooltrays-right",
	HOME_OVERLAY_MODAL: "portal-root-home-overlay-modal",
} as const;
